export const initInsights = () => {
	document.addEventListener('htmx:afterSettle', () => {
		const filters = document.querySelector('[data-insights-category]')

		if (!filters) return

		const url = new URL(window.location.href)
		const category = filters.dataset.insightsCategory

		if (category) {
			url.searchParams.set('category', category)
		} else {
			url.searchParams.delete('category')
		}

		if (url.href !== window.location.href) {
			history.replaceState(history.state, '', url)
		}
	})
}
